import React, { useRef } from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import { styled } from "@mui/material";
import { accordionSummaryClasses } from "@mui/material";
import DoubleArrowSharpIcon from "@mui/icons-material/DoubleArrowSharp";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const StyledAccordion = styled(Accordion)(({ theme }) => ({
  boxShadow: "2px 2px 6px #cccccc",
  marginBottom: 8,

  // Root element when expanded
  "&.Mui-expanded": {
    marginBottom: "8px !important",
  },
}));

const StyledAccordionSummary = styled(AccordionSummary)(({ theme }) => ({
  backgroundColor: theme.palette.brand?.red,
  boxShadow: "2px 2px 6px #cccccc",
  color: theme.palette.common.white,
  flexDirection: "row-reverse",
  minHeight: "48px",

  // Root element when expanded
  "&.Mui-expanded": {
    minHeight: "48px !important",
  },

  // Rotate only the expand icon when expanded
  [`& .${accordionSummaryClasses.expandIconWrapper}.${accordionSummaryClasses.expanded}`]:
    {
      transform: "rotate(90deg)",
    },
}));

const StyledAccordionSummarySub = styled(AccordionSummary)(({ theme }) => ({
  // boxShadow: "1px 1px 3px #cccccc",
  minHeight: "48px",

  // Root element when expanded
  "&.Mui-expanded": {
    minHeight: "48px !important",
    backgroundColor: "#f4efef",
  },
}));

const StyledExpandMoreIcon = styled(DoubleArrowSharpIcon)({
  color: "white",
  marginRight: 2,
});

const StyledSubExpandMoreIcon = styled(ExpandMoreIcon)(({ theme }) => ({
  color: theme.palette.brand?.red,
}));

export default function AccordionPanel({
  summary,
  children,
  defaultExpanded = false,
  expanded,
  onExpandedChange,
  variant = "main",
  scrollOnExpand = true,
}) {
  const detailsRef = useRef(null);
  const isControlled = typeof expanded === "boolean";

  const handleExpand = (event, expanded) => {
    if (onExpandedChange) {
      onExpandedChange(expanded);
    }

    if (!expanded || !scrollOnExpand || !detailsRef.current) return;

    // Wait for MUI's expand animation, then scroll into view
    setTimeout(() => {
      requestAnimationFrame(() => {
        detailsRef.current?.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      });
    }, 120);
  };

  return (
    <StyledAccordion
      defaultExpanded={isControlled ? undefined : defaultExpanded}
      expanded={isControlled ? expanded : undefined}
      onChange={handleExpand}
    >
      {variant === "main" ? (
        <StyledAccordionSummary expandIcon={<StyledExpandMoreIcon />}>
          {summary}
        </StyledAccordionSummary>
      ) : (
        <StyledAccordionSummarySub expandIcon={<StyledSubExpandMoreIcon />}>
          {summary}
        </StyledAccordionSummarySub>
      )}
      <AccordionDetails
        ref={detailsRef}
        style={
          variant === "sub"
            ? { padding: 8, backgroundColor: "#f9f9f9" }
            : { padding: 8 }
        }
      >
        {children}
      </AccordionDetails>
    </StyledAccordion>
  );
}
